module.exports = __webpack_public_path__ + "img/ricercatrice.e647e83e.jpg";